<template>
  <div class="shipment-tag-wrapper shipment-tag-latam-cargo">
    <div class="shipment-tag-header">
      <div class="shipment-tag-header-left">
        <img
          class="in-center"
          :src="shippingCompanyIcon"
          alt="Logo da Latam"
        />
      </div>
      <div class="shipment-tag-header-center">
        <canvas class="melhor-ponto-code in-center"></canvas>
      </div>
      <div class="shipment-tag-header-right">
        <img
          class="in-center"
          :src="$parent.tag.companyIcon"
          alt="Logo do Melhor Envio"
        />
      </div>
    </div>

    <div>
      <div class="shipment-tag-website">
        {{ $parent.tag.website }}
      </div>
    </div>

    <div class="shipment-tag-info">
      <div class="field left">
        <span style="font-size: 8pt;" v-if="$parent.tag.invoice.number">NF: {{ $parent.tag.invoice.number }}</span>
        <span v-show="$parent.tag.generatedAt && $parent.tag.protocol" style="font-size: 8pt;">{{ $parent.tag.protocol }}</span>
      </div>
      <div class="field right">
        <span v-if="$parent.tag.volumeIndex + 1">
          Volume: <strong>{{ $parent.tag.volumeIndex + 1 }}/{{ $parent.tag.volumeTotal }}</strong>
        </span>
        <span v-if="$parent.tag.package.weight">Peso (g): <strong>{{ kilogramsToGrams($parent.tag.package.weight) }}</strong></span>
      </div>
    </div>

    <p class="mt-4 text-subtitle font-normal text-center">{{ tagTracking }}</p>

    <canvas class="barcode"
      :data-value="tagTracking"
      data-height="50"
      data-margin="0"
      data-displayvalue="false">
    </canvas>

    <div class="shipment-tag-client shipment-tag-to">
      <h2 class="text-left">DESTINATÁRIO</h2>
      <p class="line">
        {{ $parent.tag.to.name }}<template v-if="$parent.tag.to.phone.length">, TEL: {{ maskPhone($parent.tag.to.phone) }}</template>
      </p>
      <p class="line">
        {{ $parent.tag.to.address }}<template v-if="$parent.tag.to.locationNumber.length">, </template>
        {{ $parent.tag.to.locationNumber }}
      </p>
      <p class="line">
        {{ $parent.tag.to.complement }}<template v-if="$parent.tag.to.complement.length">, </template>
        {{ $parent.tag.to.district }}
      </p>
      <p class="line">
        <strong>{{ beautifyPostalCode($parent.tag.to.postalCode) }}</strong> {{ $parent.tag.to.city }}<template v-if="$parent.tag.to.stateAbbr.length">/</template>{{ $parent.tag.to.stateAbbr }}
      </p>
      <p class="line">
        <span v-show="$parent.tag.to.note.length">OBS: {{ $parent.tag.to.note }}</span>
      </p>
      <p class="line" v-show="!$parent.tag.collect">
        <strong class="small-line">POSTAR EM:</strong>
        <strong class="small-line">{{ $parent.tag.agency ? $parent.tag.agency : 'AGÊNCIA NÃO SELECIONADA'}}</strong>
      </p>
      <p>
        <canvas class="barcode"
           :data-value="$parent.tag.to.postalCode"
           data-height="34"
           data-margin="0"
           data-displayvalue="false">
        </canvas>
      </p>
      <div class="shipment-tag-optionals">
        <span v-show="$parent.tag.collect">C</span>
      </div>
    </div>

    <div class="shipment-tag-client">
      <h2 class="text-left">REMETENTE</h2>
      <p class="line">
        {{ $parent.tag.from.name }}<template v-if="$parent.tag.from.phone.length">, TEL: {{ maskPhone($parent.tag.from.phone) }}</template>
      </p>
      <p class="line">
        {{ $parent.tag.from.address }}<template v-if="$parent.tag.from.locationNumber.length">, </template>
        {{ $parent.tag.from.locationNumber }}
      </p>
      <p class="line">
        {{ $parent.tag.from.complement }}<template v-if="$parent.tag.from.complement.length">, </template>
        {{ $parent.tag.from.district }}
      </p>
      <p class="line">
        <strong>{{ beautifyPostalCode($parent.tag.from.postalCode) }}</strong> {{ $parent.tag.from.city }}<template v-if="$parent.tag.from.stateAbbr.length">/</template>{{ $parent.tag.from.stateAbbr }}
      </p>
    </div>
  </div>
</template>

<script>
  import { kilogramsToGrams, maskPhone } from 'commons/js/formatters/Mask';
  import { beautifyPostalCode } from 'commons/js/formatters/PostalCode';
  import MelhorPontoQrCode from 'commons/js/mixins/melhorPontoQrCode';

  export default {
    mixins: [MelhorPontoQrCode],

    data() {
      return {
        shippingCompanyIcon: '/images/shipment/latam-cargo/logo-negativo.png'
      }
    },

    computed: {
      tagTracking() {
        return String(this.$parent.tag.tracking).replace('LTM-', '');
      },
    },

    mounted() {
      BarCode('.barcode').init();
    },

    methods: {
      kilogramsToGrams,
      maskPhone,
      beautifyPostalCode
    }
  }
</script>

<style lang="stylus" scoped>
.shipment-tag-latam-cargo
  .text-left
    text-align left
  strong
    font-weight bold
  .shipment-tag-header
    height 110px
    .in-center
      position absolute
      top 50%
      left 50%
      transform translate(-50%, -50%)
    img
      width 90%
    .shipment-tag-header-left
    .shipment-tag-header-center
    .shipment-tag-header-right
      position relative
      width 33.33%
      height 100%
      display inline-block
    .shipment-tag-header-left
      float left
    .shipment-tag-header-center
      margin 0 auto
    .shipment-tag-header-right
      float right
  .shipment-tag-info
    .field
      width 33.33%
      text-align center
      margin-top -12px
      line-height 1
      &.left
        float left
      &.right
        float right
      span
        height 12px
        display block
  .shipment-tag-website
    font-size 7pt !important
    width 33.33%
    float right
    text-align center
    margin-top -30px
    font-weight bold
  .barcode
    max-width 90%
  .shipment-tag-client
    margin 5px 0
    padding 0 5px
    position relative
    .line
      padding-right 1px !important
    h2
      margin 5px 0
      font-weight bold
    p
      margin 0
      white-space nowrap
      text-transform uppercase
    &.shipment-tag-to
      border-top 2px solid #000
      border-bottom 2px solid #000
      .barcode
        margin-top 8px
        margin-bottom 5px
  .shipment-tag-optionals
    position absolute
    top 5px
    right 5px
    font-weight bold
    line-height 1.1
    span
      width 45px
      text-align center
      font-size 16pt
      border 1px solid #000
      padding 5px
      margin-bottom 5px
      display block

@media print
  .shipment-tag-latam-cargo
    .shipment-tag-header
      height 110px !important

      img
        width 85%

    .shipment-tag-website
      display block
</style>
